import { TelemetryContext } from './TelemetryContext';
import {
  DataDisplayedInSharedDialog,
  TelemetryEvents,
} from './TelemetryEvents';
import { telemetrySender } from './TelemetrySender';

class SharedDialogTelemetry {
  public sendDataDisplayedInSharedDialog = (typeOfDataDisplayed: string, displayDuration: number, telemetryContext: TelemetryContext) => {
    telemetrySender.sendEvent<DataDisplayedInSharedDialog>({
      type: TelemetryEvents.DataDisplayedInSharedDialog,

      typeOfDataDisplayed: typeOfDataDisplayed,
      displayDuration: displayDuration,
    }, telemetryContext, 'empty');
  }
}


export const sharedDialogTelemetry: SharedDialogTelemetry = new SharedDialogTelemetry();
